// extracted by mini-css-extract-plugin
export default {"buttons":"EditDealerPage_buttons__ysqR-","left":"EditDealerPage_left__i07xI","right":"EditDealerPage_right__WHm2H"};